import { AES } from 'crypto-js';
import Css from "./AdminNavbar.css";
import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../images/logo/to-logo.svg";
import { useSelector, useDispatch } from "react-redux";
import Notification from "../Notification/Notification";
import React, { useState, useEffect, useRef } from "react";
import user_profile from "../../images/user/Default_pfp.png";
import { logout, reset } from "../../features/auth/authSlice";
import { setHeaderText } from "../../features/headerText/headerTextSlice";
import { reset as invoiceReset } from "../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../features/appSettings/appSettingsSlice.js";
import { resetAccountDetails } from "../../features/accountDetails/accountDetailsSlice.js";
import Pusher from 'pusher-js';
import userCategory from '../../constants/userCategory.js';
import InactivityHandler from "./InactivityHandler.jsx";
import Sidebar from "../Sidebar/Sidebar.jsx"


const AdminNavbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth);
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [dashboardText, setDashboardText] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const userSectionRef = useRef(null);
  const location = useLocation();
  const headerText = useSelector(
    (state) => state.headerText.headerTextState
  );
  const { appSettings } = useSelector((state) => state.appSettings);
  const userId = useSelector((state) => state.auth.user._id);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setIsActive(!isActive);
    dispatch(resetAccountDetails());
  };

  const profileSetting = () => {
    dispatch(setHeaderText("Profile Settings"));
    localStorage.setItem('activeTab', '0');
    setIsOpen(false);
  };

  // useEffect(() => {

  //   // Initialize Pusher with your app key and cluster

  //   const pusher = new Pusher('77dbc32bce6ebdabdbc8', {
  //     cluster: 'ap1',
  //     encrypted: true,
  //   });

  //   // Subscribe to the channel and event you used in the backend
  //   const channel = pusher.subscribe(userId);
  //   channel.bind('userLogout', (data) => {

  //     localStorage.removeItem("user");
  //     dispatch(logout());
  //     dispatch(reset());
  //     dispatch(invoiceReset());
  //     dispatch(headerReset());
  //     dispatch(appSettingsReset());
  //     document.body.classList.remove('open-menu-mob');
  //     window.location.reload();

  //   });

  //   channel.bind('userRefresh', (data) => {
  //     window.location.reload();
  //   });

  //   const channel2 = pusher.subscribe('allUsers');

  //   channel2.bind('forceLogout', (data) => {

  //     localStorage.removeItem("user");
  //     dispatch(logout());
  //     dispatch(reset());
  //     dispatch(invoiceReset());
  //     dispatch(headerReset());
  //     dispatch(appSettingsReset());
  //     document.body.classList.remove('open-menu-mob');
  //     window.location.reload();

  //   });

  //   channel2.bind('forceReload', (data) => {

  //     window.location.reload();

  //   });

  //   // Cleanup on unmount
  //   return () => {
  //     channel.unbind_all();
  //     channel.unsubscribe();
  //   };
  // }, []);

  useEffect(() => {
    const initializePusher = async () => {
        // Initialize Pusher with your app key and cluster
        const pusher = new Pusher('77dbc32bce6ebdabdbc8', {
            cluster: 'ap1',
            encrypted: true,
        });

        // Subscribe to the user-specific channel and event
        const channel = pusher.subscribe(userId);
        channel.bind('userLogout', (data) => {
            localStorage.removeItem("user");
            dispatch(logout());
            dispatch(reset());
            dispatch(invoiceReset());
            dispatch(headerReset());
            dispatch(appSettingsReset());
            document.body.classList.remove('open-menu-mob');
            window.location.reload();
        });

        channel.bind('userRefresh', (data) => {
            window.location.reload();
        });

        // Subscribe to the 'allUsers' channel for global events
        const channel2 = pusher.subscribe('allUsers');
        channel2.bind('forceLogout', (data) => {
            localStorage.removeItem("user");
            dispatch(logout());
            dispatch(reset());
            dispatch(invoiceReset());
            dispatch(headerReset());
            dispatch(appSettingsReset());
            document.body.classList.remove('open-menu-mob');
            window.location.reload();
        });

        channel2.bind('forceReload', (data) => {
            window.location.reload();
        });

        // Cleanup on unmount
        return () => {
            channel.unbind_all();
            channel.unsubscribe();
            channel2.unbind_all();
            channel2.unsubscribe();
        };
    };

    // Call the async function to initialize Pusher
    initializePusher();

}, [userId, dispatch]);  // Dependencies to re-run effect when `userId` or `dispatch` change


  // useEffect(() => {
  //   const handleBodyClick = (event) => {
  //     if (userSectionRef.current && !userSectionRef.current.contains(event.target)) {
  //       setIsOpen(false);
  //       setIsActive(false);
  //       document.body.classList.remove("open-menu-mob");
  //     }
  //   };
  //   document.body.addEventListener("click", handleBodyClick);
  //   return () => {
  //     document.body.removeEventListener("click", handleBodyClick);
  //   };
  // }, []);

  useEffect(() => {
    const handleBodyClick = (event) => {
        if (userSectionRef.current && !userSectionRef.current.contains(event.target)) {
            // Use setTimeout to ensure the updates are non-blocking
            setTimeout(() => {
                setIsOpen(false);
                setIsActive(false);
                document.body.classList.remove("open-menu-mob");
            }, 0); // 0 ms ensures it happens after current event handling
        }
    };

    document.body.addEventListener("click", handleBodyClick);

    // Cleanup the event listener on unmount
    return () => {
        document.body.removeEventListener("click", handleBodyClick);
    };
}, []); // Empty dependency array ensures it runs once on mount and cleanup on unmount

  useEffect(() => {
    if (isActive) {
      document.body.classList.add("open-menu-mob");
    } else {
      document.body.classList.remove("open-menu-mob");
    }
  }, [isActive]);

  const handleCloseSideBar = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (headerText) {
      setDashboardText(headerText);
    }
    setProfileImage(user.user.profile_image);
  }, [headerText, user]);

  return (
    <div className='navbar-outer'>
      <div className='navbar-inner'>
        <div className='navbar-lf'>
          {/* <h1 className='logo-main-nav-text-m11'>{global.config.locate(appSettings && appSettings.language, dashboardText)}</h1> */}
          <h1 className='logo-main-nav-text-m11'>{dashboardText}</h1>
          <img className='image-for-mob-only-nav1' src={logo} alt="Logo" />
        </div>
        <div className="navbar-rt">
          {user.user.is_notification_enabled === true && (user && (user.user.userCategory !== userCategory.Vendor) && (user.user.userCategory !== userCategory.Client)) && (
            <div className="nav-noti">
              <Notification />
            </div>
          )}
          <div className={`user-sec ${isActive ? "active" : ""}`} ref={userSectionRef}>
            <div className="user-inner">
              <div className="user-img" onClick={toggleDropdown}>
                {user.isLoading ? (
                  <img src={user_profile} alt="User" />
                ) : (
                  <>
                    {user.user && user.user.profile_image && user.user.profile_image !== "null" ? (
                      <>
                        {profileImage ? (<img
                          // src={`/uploads/orgiProfileImage/${profileImage}`}
                          src={
                            user.user.userCategory === userCategory.Vendor
                              ? `/uploads/vendorCompyLogo/orgiQuality/${profileImage}`
                              : user.user.userCategory === userCategory.Client
                                ? `/uploads/clientCompyLogo/orgiQuality/${profileImage}`
                                : `/uploads/orgiProfileImage/${profileImage}`
                          }
                          alt="User"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/uploads/lowProfileImage/user_default.png';
                          }}
                        />) : "Loading.."}
                      </>
                    ) : (
                      <img src={user_profile} alt="User" />
                    )}
                  </>
                )}
              </div>
              {isOpen && (
                <div className="inner-profile">
                  <div className='mobile-menu-new-outer'>
                    <div className="mobile-menu-new">
                      <Sidebar onCancel={handleCloseSideBar} />
                    </div>
                    <div className='sidebar-mob-sec'>
                      <Link to="/user/profile/settings" className={headerText === "Profile Settings" ? "active" : ""} onClick={profileSetting}>
                        <span className='icon-menu'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                            <path d="M16.5334 5.00821L21.3308 5.0021C21.7028 5.00162 22.0047 4.6973 22.0042 4.32331C22.0038 3.94932 21.7011 3.64576 21.3291 3.64624L16.5317 3.65235C16.2162 2.10709 14.8527 0.942822 13.2244 0.944897C11.5962 0.946971 10.2354 2.11471 9.92413 3.66077L1.55107 3.67144C1.1791 3.67191 0.87719 3.97623 0.877666 4.35023C0.878143 4.72422 1.18083 5.02777 1.5528 5.0273L9.92701 5.01663C10.2425 6.56189 11.606 7.72615 13.2342 7.72408C14.8625 7.722 16.2232 6.55427 16.5334 5.00821ZM11.2069 4.33706C11.2055 3.21512 12.1112 2.30218 13.2271 2.30076C14.343 2.29933 15.251 3.20996 15.2524 4.33191C15.2539 5.45386 14.3482 6.3668 13.2323 6.36822C12.1164 6.36964 11.2083 5.45901 11.2069 4.33706ZM10.4082 11.6189L21.3391 11.605C21.711 11.6045 22.0129 11.3002 22.0125 10.9262C22.012 10.5522 21.7093 10.2487 21.3373 10.2492L10.4065 10.2631C10.091 8.71782 8.72749 7.55356 7.09925 7.55563C5.4709 7.55771 4.11026 8.72544 3.79894 10.2715L1.55926 10.2744C1.18728 10.2748 0.885373 10.5792 0.88585 10.9531C0.886326 11.3271 1.18901 11.6307 1.56099 11.6302L3.80179 11.6274C4.11728 13.1726 5.48078 14.3369 7.10901 14.3348C8.73621 14.3327 10.0969 13.165 10.4082 11.6189ZM5.08173 10.9478C5.0803 9.82585 5.986 8.91291 7.1019 8.91149C8.2178 8.91007 9.12583 9.8207 9.12726 10.9426C9.12869 12.0646 8.22298 12.9775 7.10708 12.979C5.99118 12.9804 5.08316 12.0697 5.08173 10.9478ZM19.1717 18.2107L21.3473 18.2079C21.7193 18.2075 22.0212 17.9031 22.0207 17.5291C22.0203 17.1552 21.7176 16.8516 21.3456 16.8521L19.17 16.8548C18.8545 15.3096 17.491 14.1453 15.8628 14.1474C14.2345 14.1495 12.8738 15.3172 12.5624 16.8633L1.56744 16.8773C1.19546 16.8777 0.893553 17.1821 0.89403 17.5561C0.894506 17.9301 1.19719 18.2336 1.56917 18.2331L12.5653 18.2191C12.8808 19.7644 14.2443 20.9287 15.8726 20.9266C17.4998 20.9245 18.8604 19.7556 19.1717 18.2107ZM13.8452 17.5396C13.8438 16.4176 14.7495 15.5047 15.8654 15.5033C16.9813 15.5018 17.8893 16.4125 17.8908 17.5344C17.8922 18.6564 16.9865 19.5693 15.8706 19.5707C14.7547 19.5721 13.8467 18.6604 13.8452 17.5396Z" fill="#6A7988" stroke="white" stroke-width="0.3" />
                          </svg>
                        </span>
                        {global.config.locate(appSettings && appSettings.language, 'Profile_Settings')}
                      </Link>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          localStorage.removeItem("user");
                          dispatch(logout());
                          dispatch(reset());
                          dispatch(invoiceReset());
                          dispatch(headerReset());
                          dispatch(appSettingsReset());
                          document.body.classList.remove('open-menu-mob');
                          navigate("/");
                        }}
                      >
                        <span className='icon-menu'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                            <path d="M22 11.0002C22 17.0651 17.0649 22 10.9998 22C6.77443 22 2.87425 19.5352 1.05905 15.7148C0.939043 15.4645 1.04874 15.1645 1.29437 15.0502C1.5447 14.9302 1.83908 15.0398 1.95908 15.2855C3.60916 18.7552 7.15964 21.0004 10.9998 21.0004C16.5153 21.0004 21.0006 16.5152 21.0006 11C21.0006 5.48476 16.5153 0.999614 10.9998 0.999614C7.15964 0.999614 3.60916 3.24495 1.95908 6.71453C1.83908 6.96485 1.54374 7.06985 1.29437 6.94985C1.04404 6.82985 0.939035 6.53452 1.05905 6.28516C2.87413 2.46482 6.77419 0 10.9998 0C17.0649 0 22 4.93491 22 10.9998V11.0002ZM12.0247 15.0251C11.8297 15.2201 11.8297 15.5351 12.0247 15.7301C12.125 15.8304 12.2497 15.8754 12.38 15.8754C12.5103 15.8754 12.635 15.8257 12.7353 15.7301L17.1155 11.35C17.3105 11.155 17.3105 10.84 17.1155 10.645L12.7353 6.26502C12.5403 6.07001 12.2253 6.07001 12.0303 6.26502C11.8353 6.46002 11.8353 6.77502 12.0303 6.97002L15.5556 10.4952H0.499703C0.22501 10.4952 0 10.7202 0 10.9948C0 11.2695 0.22501 11.4945 0.499703 11.4945H15.5556L12.0247 15.0251Z" fill="#6A7988" />
                          </svg>
                        </span>
                        {global.config.locate(appSettings && appSettings.language, 'Logout')}
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <InactivityHandler />
    </div>

  );
};

export default AdminNavbar;